import { createSlice } from "@reduxjs/toolkit";

const initialState = { data: [], sourceDestinationFields: [] };

const step1DatasSlice = createSlice({
    name: "stepOneDatas",
    initialState,
    reducers: {
        stepOneData(state, action) {
            state.data = action.payload;
        },
        destinationAndSourceFields(state, action) {
            state.sourceDestinationFields = action.payload;
        },
    },
});

export const { stepOneData, destinationAndSourceFields } =
    step1DatasSlice.actions;
export default step1DatasSlice.reducer;
